/** Parses Spa onboarding booleans from payload, Excel, or legacy Yes/No strings. */
export const parseSpaBooleanField = (
  value: unknown,
  defaultValue = true,
): boolean => {
  if (value === true || value === "True" || value === "TRUE") {
    return true;
  }
  if (value === false || value === "False" || value === "FALSE") {
    return false;
  }
  if (value === "Yes") {
    return true;
  }
  if (value === "No") {
    return false;
  }
  return defaultValue;
};
